var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[(_vm.label)?_c('label',{staticClass:"form-label label-sm",attrs:{"for":_vm.uid}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('div',{staticClass:"form-body"},[_vm._t("default",null,{"uid":_vm.uid})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }